import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { useTheme } from '../../context/theme'
import {
  DMPrimaryButton,
  DMPrimaryAltButton,
  DMModal
} from '@decormatters/dm-theme'
import { ReactComponent as Exclamation } from '../../assets/exclamationmark.svg'
import { setModalClose } from '../../redux/designerReducers/designerReducer'

import ModalContentContainer from './ModalContentContainer'
import ModalActionContainer from './ModalActionContainer'
import useModal from '../../hooks/useModal'
import useEnterKey from '../../hooks/useEnterKey'

const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-top: 18px;
`

const ModalBody = styled.div`
  font-size: 14px;
  text-align: center;
  margin-top: 18px;
`

const DeleteConfirmation = ({ show, title, children, onClose, onDelete }) => {
  const dispatch = useDispatch()
  const { appearance } = useTheme()
  const enter = useEnterKey()
  useModal(show)

  useEffect(() => {
    if (enter) {
      dispatch(setModalClose())
      if (show === true && onDelete) onDelete()
    }
  }, [dispatch, enter, show, onDelete])

  return (
    <DMModal show={show} scheme={appearance} onClose={onClose}>
      <ModalContentContainer>
        <Exclamation />
        <ModalTitle>{title}</ModalTitle>
        <ModalBody>{children}</ModalBody>
        <ModalActionContainer>
          <DMPrimaryAltButton
            scheme={appearance}
            type="button"
            onClick={onClose}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </DMPrimaryAltButton>
          <DMPrimaryButton
            scheme={appearance}
            type="button"
            onClick={onDelete}
            style={{ marginLeft: '10px' }}
          >
            Delete
          </DMPrimaryButton>
        </ModalActionContainer>
      </ModalContentContainer>
    </DMModal>
  )
}

export default DeleteConfirmation
